import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    MultiSelectBox,
    SearchDateBox,
    SearchBox,
    DataForm,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    Title,
    TextView,
    PanelBox,
    Modal,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffOrdersPeikCancel(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp2 = () => {
        console.log('handlecomp2');
    };
    const handlecomp3 = () => {
        console.log('handlecomp3');
    };
    const handlecomp1 = () => {
        const childDialog = (
            <>
                <DataForm>
                    <Title>در انتظار تایید</Title>
                    <Grid>
                        <GridColumn width={12}>
                            <TextView>
                                تمام سفارشات انتخاب شده به قسمت در انتظار تایید منتقل شوند ؟
                            </TextView>
                        </GridColumn>
                    </Grid>
                    <LeftComponents>
                        <Button onClick={handlecomp2}>انصراف</Button>
                        <Button onClick={handlecomp3}>انتقال به در انتظار تایید</Button>
                    </LeftComponents>
                </DataForm>
            </>
        );
        setModal(
            Modal({
                children: childDialog,
                onDismiss: () => setModal(null),
            })
        );
        console.log('child-dialog');
    };
    const [formQShopIdOptions, setFormQShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-cancel/select-data/q-shop-id').then(
            (response) => {
                setFormQShopIdOptions(response.data);
            }
        );
    }, []);
    const [formQDeliverTimeIdOptions, setFormQDeliverTimeIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-cancel/select-data/q-deliver-time-id').then(
            (response) => {
                setFormQDeliverTimeIdOptions(response.data);
            }
        );
    }, []);
    const handlecomp4 = () => {
        applyFilters();
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQId('');
        setFilterQShopCode('');
        setFilterQShopId('');
        setFilterQTitle('');
        setFilterQInsertTimeFrom('');
        setFilterQInsertTimeTo('');
        setFilterQDeliverTimeId('');
        setFilterQCustomerName('');
        setFilterQCustomerMobile('');
        setFilterQAddress('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQId && (newSearchParams['q-id'] = filterQId);
        filterQShopCode && (newSearchParams['q-shop-code'] = filterQShopCode);
        filterQShopId && (newSearchParams['q-shop-id'] = filterQShopId);
        filterQTitle && (newSearchParams['q-title'] = filterQTitle);
        filterQInsertTimeFrom && (newSearchParams['q-insert-time-from'] = filterQInsertTimeFrom);
        filterQInsertTimeTo && (newSearchParams['q-insert-time-to'] = filterQInsertTimeTo);
        filterQDeliverTimeId && (newSearchParams['q-deliver-time-id'] = filterQDeliverTimeId);
        filterQCustomerName && (newSearchParams['q-customer-name'] = filterQCustomerName);
        filterQCustomerMobile && (newSearchParams['q-customer-mobile'] = filterQCustomerMobile);
        filterQAddress && (newSearchParams['q-address'] = filterQAddress);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQId, setFilterQId] = useState(allProps['q-id'] || '');
    const [filterQShopCode, setFilterQShopCode] = useState(allProps['q-shop-code'] || '');
    const [filterQShopId, setFilterQShopId] = useState(allProps['q-shop-id'] || '');
    const [filterQTitle, setFilterQTitle] = useState(allProps['q-title'] || '');
    const [filterQInsertTimeFrom, setFilterQInsertTimeFrom] = useState(
        allProps['q-insert-time-from'] || ''
    );
    const [filterQInsertTimeTo, setFilterQInsertTimeTo] = useState(
        allProps['q-insert-time-to'] || ''
    );
    const [filterQDeliverTimeId, setFilterQDeliverTimeId] = useState(
        allProps['q-deliver-time-id'] || ''
    );
    const [filterQCustomerName, setFilterQCustomerName] = useState(
        allProps['q-customer-name'] || ''
    );
    const [filterQCustomerMobile, setFilterQCustomerMobile] = useState(
        allProps['q-customer-mobile'] || ''
    );
    const [filterQAddress, setFilterQAddress] = useState(allProps['q-address'] || '');
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-cancel/table-data', {
            size: tableSize,
            page: tablePage,
            q_id: filterQId,
            q_shop_code: filterQShopCode,
            q_shop_id: filterQShopId,
            q_title: filterQTitle,
            q_insert_time_from: filterQInsertTimeFrom,
            q_insert_time_to: filterQInsertTimeTo,
            q_deliver_time_id: filterQDeliverTimeId,
            q_customer_name: filterQCustomerName,
            q_customer_mobile: filterQCustomerMobile,
            q_address: filterQAddress,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>سفارشات عدم تایید</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp1} color={'secondary'}>
                        انتقال گروهی به در انتظار تایید
                    </Button>
                </LeftComponents>
            </Row>
            <SearchBox onEnter={applyFilters} label={'شناسه'} value={filterQId} onChange={setFilterQId} width={'120px'} />
            <SearchBox onEnter={applyFilters}
                label={'کد رهگیری در فروشگاه'}
                value={filterQShopCode}
                onChange={setFilterQShopCode}
                width={'120px'}
            />
            <MultiSelectBox
                label={'فروشگاه'}
                options={formQShopIdOptions}
                value={filterQShopId}
                onChange={setFilterQShopId}
            />
            <SearchBox onEnter={applyFilters}
                label={'عنوان'}
                value={filterQTitle}
                onChange={setFilterQTitle}
                width={'120px'}
            />
            <SearchDateBox onEnter={applyFilters}
                label={'زمان درج از'}
                value={filterQInsertTimeFrom}
                onChange={setFilterQInsertTimeFrom}
                width={'100px'}
            />
            <SearchDateBox onEnter={applyFilters}
                label={'زمان درج تا'}
                value={filterQInsertTimeTo}
                onChange={setFilterQInsertTimeTo}
                width={'100px'}
            />
            <MultiSelectBox
                label={'زمان ارسال'}
                options={formQDeliverTimeIdOptions}
                value={filterQDeliverTimeId}
                onChange={setFilterQDeliverTimeId}
            />
            <SearchBox onEnter={applyFilters}
                label={'نام خریدار'}
                value={filterQCustomerName}
                onChange={setFilterQCustomerName}
                width={'120px'}
            />
            <SearchBox onEnter={applyFilters}
                label={'همراه خریدار'}
                value={filterQCustomerMobile}
                onChange={setFilterQCustomerMobile}
                width={'120px'}
            />
            <SearchBox onEnter={applyFilters}
                label={'آدرس'}
                value={filterQAddress}
                onChange={setFilterQAddress}
                width={'120px'}
            />
            <Button onClick={handlecomp4} color={'secondary'}>
                جستجو
            </Button>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>مبلغ سفارش</TableColumn>
                        <TableColumn mobile={false}>زمان ایجاد</TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_shop_id_title}</TextView>
                                <TextView>{row.text_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <RightComponents>
                                    <TextView>{row.text_customer_name}</TextView>
                                    <TextView>{row.text}</TextView>
                                    <TextView>{row.text_customer_mobile}</TextView>
                                </RightComponents>
                                <TextView bold={true}>{row.text_address}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true} format={'money'}>
                                    {row.text_payable_price}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-date-normal'}>
                                    {row.text_inserttime}
                                </TextView>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
